// extracted by mini-css-extract-plugin
export var label = "_aj-1";
export var reminder = "_aj-0";